import script from "./CustomDashboardListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardListItem.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardListItem.vue?vue&type=style&index=0&id=8462a06a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8462a06a"]])

export default __exports__